module.exports = "/img/404.8cb40ce7.jpg";